import React, { useId } from "react";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import { palette, tickStyle, tickStyleStrong, ChartTooltip, ChartEmpty } from "./ChartTheme";

/**
 * Minimal line chart for trends.
 * data: [{ period|name, count|value }] — same props/defaults as before.
 * Redesign: the line now sits over a soft gradient fill (a common,
 * subtle upgrade for trend charts) instead of a bare stroke.
 */
const LineChart = ({
  data = [],
  height = 200,
  dataKey = "count",
  xKey = "period",
  color = palette.primary,
}) => {
  const gradientId = `lineFill-${useId()}`;

  if (!data?.length) {
    return <ChartEmpty height={height} />;
  }

  return (
    <div style={{ width: "100%", height }}>
      <ResponsiveContainer>
        <AreaChart data={data} margin={{ top: 4, right: 8, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.22} />
              <stop offset="100%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke={palette.grid} vertical={false} />
          <XAxis
            dataKey={xKey}
            tick={tickStyleStrong}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            allowDecimals={false}
            tick={tickStyle}
            axisLine={false}
            tickLine={false}
            width={28}
          />
          <Tooltip
            cursor={{ stroke: palette.border, strokeWidth: 1 }}
            content={<ChartTooltip />}
          />
          <Area
            type="monotone"
            dataKey={dataKey}
            stroke={color}
            strokeWidth={2.25}
            fill={`url(#${gradientId})`}
            dot={{ r: 3, strokeWidth: 0, fill: color }}
            activeDot={{ r: 5, strokeWidth: 2, stroke: "#fff" }}
            animationDuration={350}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineChart;